import { useEffect } from 'react';
import { Dimensions, Platform, StyleSheet, StatusBar } from 'react-native';
import { Logger } from 'aws-amplify';

const minHexagramWidth = 150;
const flatListMarginRight = 16;
const logger = new Logger('layout');

const columnsFor = (w: number) => {
  const c = Math.floor((w + flatListMarginRight) / minHexagramWidth);

  // Pair number of columns unless only one column
  const r = c % 2;
  return c > 1 && r ? c - r : c || 1;
};

const orientationFor = (w: number, h: number) => (w > h ? landscape : portrait);
const isSmallDeviceFor = (w: number) => w < 375;

const portrait = 'PORTRAIT';
const landscape = 'LANDSCAPE';

export type Layout = {
  window: {
    width: number;
    height: number;
  };
  orientation: string;
  columns: number;
  isSmallDevice: boolean;
};

const { width, height } = Dimensions.get('window');

const initial = {
  window: {
    width: width - flatListMarginRight,
    height
  },
  orientation: orientationFor(width, height),
  columns: columnsFor(width),
  isSmallDevice: isSmallDeviceFor(width)
};

// @todo any, export function useLayout(layout: Layout, setLayout: (l: Dispatch<SetStateAction<Layout>>) => Layout){
export function useLayout(layout: Layout, setLayout: (l: any) => void) {
  const refreshed = { ...layout };

  let mounted = false;

  const updateDimensions = ({ window: { width: w, height: h } }: any) => {
    refreshed.window = {
      width: w - flatListMarginRight,
      height: h
    };
    refreshed.columns = columnsFor(w);
    refreshed.orientation = orientationFor(w, h);
    refreshed.isSmallDevice = isSmallDeviceFor(w);

    // @todo Can't perform a React state update on an unmounted component
    // https://stackoverflow.com/questions/53949393/cant-perform-a-react-state-update-on-an-unmounted-component
    if (mounted) setLayout(refreshed);

    logger.log(
      `changed width to ${refreshed.window.width}, now columns is ${
        refreshed.columns
      }, ${refreshed.orientation} orientation, component ${
        mounted ? 'is' : 'is not'
      } mounted`
    );
  };

  useEffect(() => {
    mounted = true;
    Dimensions.addEventListener('change', updateDimensions);

    return () => {
      Dimensions.removeEventListener('change', updateDimensions);
      mounted = false;
    };
  }, [layout, setLayout]);
}

export const mobile = Platform.OS === 'android' || Platform.OS === 'ios';

export const styles = StyleSheet.create({
  mobile: {
    marginTop: StatusBar.currentHeight || 0
  }
});

export default initial;
